/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from "react";
import Jobdetail from "./Job_detail";
import Jobprogress from "./Job_progress_record";
import Jobprogressform from "./Job_Progress_Form";
import FixedProblemAcceptance from "./Fix_Problem_Acceptance";
import FiexedProblemAcceptanceDetail from "./Fix_Problem_Acceptance_Detail";
import Fixedproblem from "./Fixed_Problem";
import FixedProblemDetail from "./Fixed_Problem_detail";
import MapFixedProblem from "./fix_problem_map_detail";
import Sparepart from "../Sparepart/Sparepart";
import Mapinfra from "../map_infra/MapInfra";
import Exclusion from "./Exclusion";
import Skeleton from "react-loading-skeleton";
import Progress from "../../full_detail_job/progress/Progress";
import Rejectjobdetail from "./Rejectjobdetail";
import { Impacttable } from "../dynamicdata";
import Cookies from "js-cookie";
import { authUserContext } from "../../../../contexts";

function Detail({
  headerdata,
  flowStep,
  CompanyId,
  OperatorId,
  ProjectId,
  Jobdata,
  Workflowdata,
  language,
  factupdate,
  setcurrentPage,
  isActive,
  setisActive,
  showFixdProblemDetail,
  setshowFixdProblemDetail,
  showFormFixdProblemDetail,
  setshowFormFixdProblemDetail,
  showJobprogress,
  setshowJobprogress,
  showFormJobprogress,
  setshowFormJobprogress,
  showFormMapFixed,
  showMapFixed,
  showAcceptanceDetail,
  setshowAcceptanceDetail,
  showAcceptanceForm,
  setshowAcceptanceForm,
}) {
  const authUserValue = useContext(authUserContext);
  const configShowComponent = authUserValue.configuration?.filter(
    (s) => (s) => s.configuration.job_full_detail.component !== null
  )[0]?.configuration.job_full_detail.component;
  // const configShow = authUserValue.configuration?.filter((s) => (s) =>
  //   s.configuration.job_full_detail.component !== null
  // )[0]?.configuration.job_full_detail.component.uih_acceptance_view.visible;
  const {
    // stoptime,
    job_progress_form,
    job_progress_view,
    fix_problem_form,
    fix_problem_view,
    fix_problem_repair_form,
    fix_problem_repair_view,
    uih_acceptance_form,
    uih_acceptance_view,
  } = configShowComponent || {};
  const [Menu, setMenu] = useState(
    uih_acceptance_view?.visible
      ? [
          { text: "Job Detail", step: 1 },
          { text: "Job Progress", step: 2 },
          { text: "บันทึกสาเหตุ", step: 3 },
          { text: "บันทึกซ่อม", step: 4 },
          { text: "UIH ตรวจรับงาน", step: 5 },
          { text: "บันทึก Material", step: 6 },
          { text: "Exclusion", step: 7 },
        ]
      : [
          { text: "Job Detail", step: 1 },
          { text: "Job Progress", step: 2 },
          { text: "บันทึกสาเหตุ", step: 3 },
          { text: "บันทึกซ่อม", step: 4 },
          {},
          { text: "บันทึก Material", step: 6 },
          { text: "Exclusion", step: 7 },
        ]
  );
  const locale = Cookies.get("locale");
  // const [isActive, setisActive] = useState(2);

  const [loading, setloading] = useState(false);
  const changeMenu = async (indexPage) => {
    if (indexPage !== null) {
      setisActive(indexPage);
      if (setcurrentPage) {
        setcurrentPage(indexPage);
      }
      await setloading(true);
      setTimeout(() => {
        setloading(false);
      }, 2000);
    }
  };

  

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          paddingBottom: "10px",
          // backgroundColor: "#FFFFFF",
        }}
      >
        {/* Change to Ant Tab Start */}
        <div className="d-flex justify-content-center align-items-center">
          {/* <ul className="nav d-block" style={{ width: "100%" }}> */}
          <ul className="nav row" style={{ width: "100%" }}>
            {Menu.map((data, index) => {
              if (data.step <= flowStep) {
                return (
                  <li
                    key={`menu_detail_${index}`}
                    // className=" nav-item mr-2 d-inline text-nowrap"
                    className="nav-item m-1 col-sm-auto"
                    style={
                      isActive === index
                        ? {
                            backgroundColor: "#0500A3",
                            color: "#ffff",
                            textAlign: "center",
                          }
                        : {
                            backgroundColor: "#DEDEDE",
                            color: "#0500A3",
                            textAlign: "center",
                          }
                    }
                  >
                    <a
                      href={null}
                      // className="nav-link font-thai-b fs-18 d-inline"
                      className="nav-link font-thai-b fs-18"
                      style={{ lineHeight: "18px" }}
                      onClick={() => changeMenu(index)}
                    >
                      {data.text}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
        {/* Change to Ant Tab End */}
        {loading ? (
          <div
            style={{
              width: "96%",
              marginLeft: "2%",
              marginTop: "1%",
              height: "400px",
            }}
          >
            <Skeleton count={1} height={400} />
          </div>
        ) : null}
        {/* ส่วนเนื้อหา */}
        {isActive === 0 && !loading ? (
          <>
            <Jobdetail
              headerdata={headerdata}
              Jobdata={Jobdata}
              language={language}
              factupdate={factupdate}
            ></Jobdetail>
            {Jobdata &&
            Jobdata.result_job_detail.length > 0 &&
            Jobdata.result_job_detail[0] &&
            Jobdata.result_job_detail[0]?.data_dynamic &&
            Jobdata.result_job_detail[0]?.data_dynamic !== "{}" ? (
              <Impacttable
                locale={locale}
                language={language}
                title={"Impact Data"}
                data={
                  Jobdata.result_job_detail[0]?.data_dynamic &&
                  Jobdata.result_job_detail[0]?.data_dynamic !== "{}"
                    ? Jobdata.result_job_detail[0]?.data_dynamic
                    : null
                }
              ></Impacttable>
            ) : null}
            <Progress
              title={"Status Report"}
              Jobdata={Jobdata}
              litemode={false}
              locale={locale}
              language={language}
              factupdate={factupdate}
            ></Progress>
          </>
        ) : null}

        {isActive === 1 && !loading ? (
          <>
            {showFormJobprogress && job_progress_form?.visible ? (
              <Jobprogressform
                jobData={Jobdata}
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
              />
            ) : null}
            {showJobprogress && job_progress_view?.visible ? (
              <Jobprogress
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                jobData={Jobdata}
              />
            ) : null}
          </>
        ) : null}
        {isActive === 2 && !loading ? (
          showFixdProblemDetail && fix_problem_view?.visible ? (
            <>
              <FixedProblemDetail
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                headerdata={headerdata}
                jobData={Jobdata}
                rereder={true}
              ></FixedProblemDetail>
              <Rejectjobdetail
                jobData={Jobdata}
                headerdata={headerdata}
              ></Rejectjobdetail>
            </>
          ) : showFormFixdProblemDetail && fix_problem_form?.visible ? (
            <>
              <Fixedproblem
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                jobData={Jobdata}
                headerdata={headerdata}
                Workflowdata={Workflowdata}
              />
              <Rejectjobdetail jobData={Jobdata}></Rejectjobdetail>
            </>
          ) : null
        ) : null}
        {isActive === 5 && !loading ? <Sparepart jobData={Jobdata} /> : null}
        {isActive === 3 && !loading ? (
          showFormMapFixed && fix_problem_repair_form?.visible ? (
            <Mapinfra
              CompanyId={CompanyId}
              OperatorId={OperatorId}
              ProjectId={ProjectId}
              headerdata={headerdata}
              Workflowdata={Workflowdata}
            ></Mapinfra>
          ) : showMapFixed && fix_problem_repair_view?.visible ? (
            <MapFixedProblem
              CompanyId={CompanyId}
              OperatorId={OperatorId}
              ProjectId={ProjectId}
              headerdata={headerdata}
              showHeader={true}
            ></MapFixedProblem>
          ) : null
        ) : null}
        {isActive === 4 && !loading ? (
          <>
            {showAcceptanceForm && uih_acceptance_form?.visible ? (
              <FixedProblemAcceptance
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                jobData={Jobdata}
                headerdata={headerdata}
                Workflowdata={Workflowdata}
              />
            ) : null}
            {showAcceptanceDetail && uih_acceptance_view?.visible ? (
              <FiexedProblemAcceptanceDetail
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                jobData={Jobdata}
                headerdata={headerdata}
              ></FiexedProblemAcceptanceDetail>
            ) : null}
          </>
        ) : null}
        {isActive === 6 && !loading ? (
          <Exclusion
            CompanyId={CompanyId}
            OperatorId={OperatorId}
            ProjectId={ProjectId}
            headerdata={headerdata}
            language={language}
            factupdate={factupdate}
            jobData={Jobdata}
          ></Exclusion>
        ) : null}
      </div>
    </>
  );
}

export default Detail;
